import {
  Authenticate,
  AuthData,
  LogoutInstruction
} from '@services/auth.services';
import {ForgotPasswordResult} from '@staff-app/models/forgotPasswordResult';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Action} from '@ngrx/store';

export enum AuthActionTypes {
  Login = '[Auth] Login',
  Logout = '[Auth] Logout',
  LoginSuccess = '[Auth] Login Success',
  AutoLoginAndRedirect = '[Auth] Auto Login and Redirect',
  LoginFailure = '[Auth] Login Failure',
  LoginRedirect = '[Auth] Login Redirect',
  SetToken = '[Auth] Set Token',
  ForgotPassword = '[Auth] Forgot Password',
  ForgotPasswordSuccess = '[Auth] Forgot Password Success',
  ForgotPasswordFailure = '[Auth] Forgot Password Failure',
  ValidateResetPasswordCode = '[Auth] Validate Reset Password Code',
  ValidateResetPasswordCodeSuccess = '[Auth] Validate Reset Password Code Success',
  ValidateResetPasswordCodeFailure = '[Auth] Validate Reset Password Code Failure',
  ResetPassword = '[Auth] Reset Password',
  ResetPasswordSuccess = '[Auth] Reset Password Success',
  ChangePassword = '[Auth] Change Password',
  ChangePasswordSuccess = '[Auth] Change Password Success',
  GetPrivacyPolicyContent = '[Auth] Get Privacy Policy Content',
  GetPrivacyPolicyContentSuccess = '[Auth] Get Privacy Policy Content Success'
}
export class Login implements Action {
  readonly type = AuthActionTypes.Login;

  constructor(public payload: Authenticate) {}
}
export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LoginSuccess;

  constructor(public payload: AuthData) {}
}
export class LoginFailure implements Action {
  readonly type = AuthActionTypes.LoginFailure;

  constructor(public payload: any) {}
}
export class LoginRedirect implements Action {
  readonly type = AuthActionTypes.LoginRedirect;
  constructor() {}
}
export class AutoLoginAndRedirect implements Action {
  readonly type = AuthActionTypes.AutoLoginAndRedirect;

  constructor(public payload: AuthData) {}
}
export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
  constructor() {}
}
export class SetToken implements Action {
  readonly type = AuthActionTypes.SetToken;
  constructor(public payload: string) {}
}
export class ForgotPassword implements Action {
  readonly type = AuthActionTypes.ForgotPassword;
  constructor(
    public payload: {
      emailAddress: string;
      captchaResponse: string;
      forgotPasswordModal: NgbActiveModal;
    }
  ) {}
}
export class ForgotPasswordSuccess implements Action {
  readonly type = AuthActionTypes.ForgotPasswordSuccess;
  constructor(
    public payload: {
      forgotPasswordResult: ForgotPasswordResult;
      forgotPasswordModal: NgbActiveModal;
    }
  ) {}
}
export class ForgotPasswordFailure implements Action {
  readonly type = AuthActionTypes.ForgotPasswordFailure;
  constructor(public payload: string) {}
}
export class ValidateResetPasswordCode implements Action {
  readonly type = AuthActionTypes.ValidateResetPasswordCode;
  constructor(
    public payload: {userId: number; emailAddress: string; resetCode: string}
  ) {}
}
export class ValidateResetPasswordCodeSuccess implements Action {
  readonly type = AuthActionTypes.ValidateResetPasswordCodeSuccess;
  constructor(public payload: ForgotPasswordResult) {}
}

export class ValidateResetPasswordCodeFailure implements Action {
  readonly type = AuthActionTypes.ValidateResetPasswordCodeFailure;
  constructor(public payload: string) {}
}
export class ResetPassword implements Action {
  readonly type = AuthActionTypes.ResetPassword;
  constructor(
    public payload: {
      userId: number;
      resetCode: string;
      newPassword: string;
      resetPasswordModal: NgbActiveModal;
    }
  ) {}
}
export class ResetPasswordSuccess implements Action {
  readonly type = AuthActionTypes.ResetPasswordSuccess;
  constructor(
    public payload: {
      newPassword: string;
      resetPasswordResult: ForgotPasswordResult;
      resetPasswordModal: NgbActiveModal;
    }
  ) {}
}
export class ChangePassword implements Action {
  readonly type = AuthActionTypes.ChangePassword;
  constructor(
    public payload: {
      userId: number;
      newPassword: string;
    }
  ) {}
}
export class ChangePasswordSuccess implements Action {
  readonly type = AuthActionTypes.ChangePasswordSuccess;
  constructor(
    public payload: {
      userId: number;
      newPassword: string;
    }
  ) {}
}
export class GetPrivacyPolicyContent implements Action {
  readonly type = AuthActionTypes.GetPrivacyPolicyContent;
  constructor() {}
}
export class GetPrivacyPolicyContentSuccess implements Action {
  readonly type = AuthActionTypes.GetPrivacyPolicyContentSuccess;
  constructor(public payload: string) {}
}

export type AuthActions =
  | Login
  | LoginSuccess
  | AutoLoginAndRedirect
  | LoginFailure
  | LoginRedirect
  | Logout
  | SetToken
  | ForgotPasswordSuccess
  | ForgotPasswordFailure
  | ForgotPassword
  | ValidateResetPasswordCodeSuccess
  | ValidateResetPasswordCodeFailure
  | ValidateResetPasswordCode
  | ResetPassword
  | ResetPasswordSuccess
  | ChangePassword
  | ChangePasswordSuccess
  | GetPrivacyPolicyContent
  | GetPrivacyPolicyContentSuccess;
